/*
 * @Autor: yingna.gao
 * @Date: 2022-07-29 14:15:34
 * @LastEditTime: 2022-08-23 10:18:17
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/api/orgManage/index.js
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  // 列表
  getList: params => request({
    url: `${requestUrl}/organization/tenant-admin/page`,
    method: "get",
    params
  }),
  // 删除
  deleteItems: params => request({
    url: `${requestUrl}/organization/${params}`,
    method: "delete"
  }),
  // 弹窗-客户查询
  searchCustom: params => request({
    url: `${requestUrl}/tenant/platform`,
    method: "get",
    params
  }),
  // 根据客户角色查询对应菜单
  getCustomRoleMenu(params) {
    return request({
      url: `${requestUrl}/menus`,
      method: "get",
      params
    });
  },
  // 创建组织
  createOrg: params => request({
    url: `${requestUrl}/organization/tenant-admin`,
    method: "post",
    data: params
  }),
  // 获取顶级组织
  getOrgTop: () => request({
    url: `${requestUrl}/organization/tenant/top-org`,
    method: "get"
  }),
  updateOrg: params => request({
    url: `${requestUrl}/organization/tenant-admin`,
    method: "put",
    data: params
  }),
  updateOrgEffect: params => request({
    url: `${requestUrl}/organization/effect`,
    method: "put",
    data: params
  }),
  getUsersByOrg: params => request({
    url: `${requestUrl}/tenant/${params.id}/users`,
    method: "get",
    params
  }),
  allotUserToOrg: params => request({
    url: `${requestUrl}/tenant/shareOtherOrg`,
    method: "put",
    params
  }),
  // 根据id查询用户详情
  getDetailsById: (id, params) => request({
    url: `${requestUrl}/organization/${id}`,
    method: "get",
    params
  })
};

export default api;
